import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { SiteApiService } from './site.apiservice';
import { SiteService } from './site.service';
import { catchError, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class EcommerceService {
  private isEcommerceEnabled$$: BehaviorSubject<boolean> = new BehaviorSubject(undefined);
  isEcommerceEnabled$: Observable<boolean> = this.isEcommerceEnabled$$.asObservable();

  private loading$$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  loading$: Observable<boolean> = this.loading$$.asObservable();

  constructor(private api: SiteApiService, private siteService: SiteService) {
    this.siteService
      .get()
      .pipe(
        switchMap((site) => this.api.isEcommerceEnabled(site.accountId)),
        tap((enabled) => {
          this.isEcommerceEnabled$$.next(enabled);
          this.loading$$.next(false);
        }),
        catchError(() => {
          this.isEcommerceEnabled$$.next(false);
          this.loading$$.next(false);
          return of(null);
        }),
      )
      .subscribe();
  }
}
